import React, { Component, memo } from "react";
import WithStyles from "shared/components/WithStyles";
import { defaultStyles } from "./styles";
import { IDropdownPropsTypes, IDropdownStateTypes, IListItem } from "./types";

class Dropdown extends Component<IDropdownPropsTypes, IDropdownStateTypes> {
    public state: IDropdownStateTypes = {
        listVisible: false,
        display: "",
        selected: (this.props.selectedValue
            ? this.props.list.find(item => this.props.selectedValue === item.value)
            : this.props.list[0]) || { name: "", value: "" },
    };

    public select = (item: IListItem) => {
        this.setState({ selected: item }, () => {
            const { selected } = this.state;
            this.props.onSelect(selected);
        });
    };

    public show = () => {
        this.setState({ listVisible: true });
        document.addEventListener("click", this.hide);
    };

    public hide = () => {
        this.setState({ listVisible: false });
        document.removeEventListener("click", this.hide);
    };

    public renderListItems = () => {
        return this.props.list.map(item => (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events
            <li
                // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                role="button"
                tabIndex={0}
                className={"dropdown__item"}
                key={`${item.name}_${item.value}`}
                onClick={() => this.select(item)}
                data-test={`item-${item.value}`}
            >
                <span>{item.name}</span>
                <i className="icon-check" />
            </li>
        ));
    };

    public componentWillUnmount() {
        document.removeEventListener("click", this.hide);
    }

    public render() {
        const dropdownClasses = [
            "dropdown",
            this.state.listVisible ? "show" : "",
            this.props.className,
        ];

        return (
            <WithStyles cssProps={defaultStyles}>
                <div data-test="dropdown-cnt" className={dropdownClasses.join(" ")}>
                    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
                    <div
                        role="button"
                        tabIndex={0}
                        className={"dropdown__selected"}
                        onClick={this.show}
                    >
                        <span data-test="selected-value">{this.state.selected.name}</span>
                    </div>
                    <ul className="dropdown__list">{this.renderListItems()}</ul>
                </div>
            </WithStyles>
        );
    }
}

export default memo(Dropdown);
